import type { CookieOptionsWithName } from "@supabase/ssr"

/**
 * Atributos de las cookies de sesión de Supabase (`sb-<ref>-auth-token[.N]`).
 * TODO `createServerClient` / `createBrowserClient` del repo los recibe como
 * `cookieOptions` — lo exige `__tests__/supabaseAuthCookieSecure.guard.test.ts`.
 *
 * Por qué: los requisitos de seguridad de Intuit para QuickBooks («Cookie
 * management») piden Secure en las cookies de sesión. @supabase/ssr 0.10.2
 * pone por defecto `{ path: "/", sameSite: "lax", httpOnly: false, maxAge: 400
 * días }`, SIN `secure`. Esto sólo agrega `secure: true`: la librería mezcla
 * `{ ...DEFAULT_COOKIE_OPTIONS, ...cookieOptions }`, así que path, sameSite y
 * maxAge siguen siendo los suyos.
 *
 * NO agregues `httpOnly: true` aquí: el cliente del navegador (getAuthClient)
 * lee y renueva la sesión desde `document.cookie`, y POS/KDS/realtime dependen
 * de eso. Ver docs/superpowers/specs/2026-10-13-cookie-sesion-httponly-analisis.md.
 *
 * Desarrollo: Chrome, Firefox y Safari reciente tratan http://localhost como
 * contexto seguro y aceptan la cookie. Una IP de LAN por http (p. ej. abrir el
 * dev server desde una tablet en http://192.168.x.x:3000) NO: ahí el login no
 * persiste. Usá localhost o un túnel https.
 */
export const SUPABASE_AUTH_COOKIE_OPTIONS: CookieOptionsWithName = {
  secure: true,
}
